import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box,
  CircularProgress,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Chip,
  Pagination
} from '@mui/material';

import Filter from './Filter';

const Usersdataset = () => {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    totalPages: 1,
    hasNext: false,
    hasPrevious: false
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [filter, setFilter] = useState('');

  const fetchAssignments = async (params = {}) => {
    setLoading(true);
    setError('');
    try {
      const response = await axios.get('/api/v1/alldatasetassignments', {
        params: {
          username: params.username || filter,
          page: params.page || pagination.currentPage,
          pageSize: params.pageSize || pagination.pageSize
        }
      });

      setData(response.data.data || []);
      setPagination(response.data.pagination || {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        totalPages: 1,
        hasNext: false,
        hasPrevious: false
      });
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'Failed to fetch assignments.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAssignments();
  }, [pagination.currentPage, pagination.pageSize]);

  const handleApplyFilter = () => {
    fetchAssignments({ username: filter, page: 1 });
    setPagination(prev => ({ ...prev, currentPage: 1 }));
  };

  const handlePageChange = (event, newPage) => {
    setPagination(prev => ({ ...prev, currentPage: newPage }));
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold', mb: 4 }}>
        Dataset Assignments
      </Typography>

      <Filter filter={filter} setFilter={setFilter} onApply={handleApplyFilter} />

      <TableContainer component={Paper} elevation={3} sx={{ borderRadius: 2, overflow: 'hidden', mb: 3 }}>
        <Table>
          <TableHead sx={{ backgroundColor: 'primary.main' }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold', color: 'primary.contrastText' }}>Assignment ID</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: 'primary.contrastText' }}>User</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: 'primary.contrastText' }}>Dataset</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: 'primary.contrastText' }}>Status</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: 'primary.contrastText' }}>Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length > 0 ? (
              data.map((row) => (
                <TableRow key={row.id} hover>
                  <TableCell>{row.id}</TableCell>
                  <TableCell>{row.subscribe_user?.username || '-'}</TableCell>
                  <TableCell>{row.freedatasets?.eventName || '-'}</TableCell>
                  <TableCell>
                    <Chip
                      label={row.status.charAt(0).toUpperCase() + row.status.slice(1)}
                      color={row.status === 'assigned' ? 'success' : (row.status === 'in-progress' ? 'info' : 'warning')}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" color="text.secondary">
                      {new Date(row.createdAt).toLocaleDateString()} <br />
                      <Box component="span" sx={{ fontSize: '0.75rem', color: 'text.disabled' }}>
                        {new Date(row.createdAt).toLocaleTimeString()}
                      </Box>
                    </Typography>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                  <Typography>No dataset assignments found</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {pagination.totalPages > 1 && (
        <Box display="flex" justifyContent="center" mt={3}>
          <Pagination
            count={pagination.totalPages}
            page={pagination.currentPage}
            onChange={handlePageChange}
            color="primary"
            showFirstButton
            showLastButton
            size="large"
          />
        </Box>
      )}
    </Container>
  );
};

export default Usersdataset;
